// src/ui/ResultsPanel.js
export class ResultsPanel {
  constructor({ langManager }) {
    this._lm = langManager;
    this._el = this._build();
  }

  get element() { return this._el; }

  _build() {
    const el = document.createElement('div');
    el.className = 'panel-right';
    el.setAttribute('aria-live', 'polite');
    el.setAttribute('aria-label', 'Calculation results');
    el.innerHTML = `
      <p class="results-label" data-i18n="results.label"></p>
      <div class="result-rows">
        <div class="result-row">
          <span class="result-name" data-i18n="results.net"></span>
          <div class="result-value-row">
            <span class="result-value" data-slot="ht">—</span>
            <button class="copy-btn" aria-label="Copy net amount" data-copy="ht">
              <i class="ti ti-copy"></i>
            </button>
          </div>
        </div>
        <div class="result-row">
          <span class="result-name" data-i18n="results.vat"></span>
          <div class="result-value-row">
            <span class="result-value accent" data-slot="vat">—</span>
            <button class="copy-btn" aria-label="Copy VAT amount" data-copy="vat">
              <i class="ti ti-copy"></i>
            </button>
          </div>
        </div>
        <div class="result-row">
          <span class="result-name" data-i18n="results.gross"></span>
          <div class="result-value-row">
            <span class="result-value" data-slot="ttc">—</span>
            <button class="copy-btn" aria-label="Copy gross amount" data-copy="ttc">
              <i class="ti ti-copy"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="rate-badge-wrap">
        <span class="rate-badge" data-slot="badge"></span>
      </div>
    `;
    this._bindCopy(el);
    return el;
  }

  _bindCopy(el) {
    el.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-copy]');
      if (!btn) return;
      const slot = btn.dataset.copy;
      const valueEl = el.querySelector(`[data-slot="${slot}"]`);
      const raw = valueEl.dataset.raw;
      if (!raw) return;
      navigator.clipboard.writeText(raw).catch(() => {});
      btn.innerHTML = '<i class="ti ti-check" style="color:#22c55e;"></i>';
      setTimeout(() => { btn.innerHTML = '<i class="ti ti-copy"></i>'; }, 1200);
    });
  }

  update({ ht, vat, ttc, rate, currency, locale }) {
    const fmt = (n) =>
      new Intl.NumberFormat(locale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(n);

    const setSlot = (slot, value) => {
      const el = this._el.querySelector(`[data-slot="${slot}"]`);
      el.textContent = `${fmt(value)} ${currency}`;
      el.dataset.raw = value.toFixed(2);
    };

    setSlot('ht', ht);
    setSlot('vat', vat);
    setSlot('ttc', ttc);

    const badgeFn = this._lm.t('badge.applied');
    const badgeText = typeof badgeFn === 'function' ? badgeFn(rate) : badgeFn;
    const badge = this._el.querySelector('[data-slot="badge"]');
    badge.innerHTML = `<i class="ti ti-percentage" style="font-size:11px;"></i> ${badgeText}`;
  }

  updateTranslations() {
    this._el.querySelectorAll('[data-i18n]').forEach((el) => {
      el.textContent = this._lm.t(el.dataset.i18n);
    });
  }
}
